import { render } from "./CallEmptyState.vue.js?vue&type=template&id=4b6995e6!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallEmptyState.vue?vue&type=template&id=4b6995e6"
import script from "./CallEmptyState.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallEmptyState.vue?vue&type=script&lang=js"
export * from "./CallEmptyState.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallEmptyState.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/video-engine/components/video-call/CallEmptyState.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b6995e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b6995e6', __exports__)) {
    api.reload('4b6995e6', __exports__)
  }
  
  module.hot.accept("./CallEmptyState.vue.js?vue&type=template&id=4b6995e6!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallEmptyState.vue?vue&type=template&id=4b6995e6", () => {
    api.rerender('4b6995e6', render)
  })

}


export default __exports__